import { 
  BRANDKIT_INITIATE_MEDIA_UPLOAD, BRANDKIT_INVALIDATE_MEDIA_UPLOAD_ERROR, BRANDKIT_UPDATE_MEDIA_UPLOAD_PROGRESS, 
  BRANDKIT_UPLOAD_MEDIA_REQUEST, BRANDKIT_UPLOADING_MEDIA_SUCCEEDED, BRANDKIT_UPLOADING_MEDIA_FAILED,
  BRANDKIT_SEARCH_MEDIA_REQUEST, BRANDKIT_SEARCHING_MEDIA_SUCCEEDED, BRANDKIT_SEARCHING_MEDIA_FAILED, 
  BRANDKIT_DELETE_MEDIA_REQUEST, BRANDKIT_DELETING_MEDIA_SUCCEEDED, BRANDKIT_DELETING_MEDIA_FAILED, 
  BRANDKIT_INVALIDATE_MEDIA_LIBRARY, BRANDKIT_INVALIDATE_MEDIA_DELETE_ERROR,
  RELOAD_EDITOR_BRAND_COMPONENT_SUCCEEDED
} from 'constants/actionTypes';
  
  import _ from 'lodash';
  
  const initialState = {
    loading: false,
    fetched: false,
    invalidated: false,
    errorType: null,
    items: [],
    pagination: {
      currentPage: 0,
      totalPages: 0,
    },
    uploads: [],
  }
  
  export function brandKitMediaReducer(state = initialState, action) {
    switch (action.type) {
  
      case BRANDKIT_INITIATE_MEDIA_UPLOAD: {
        const request = action.payload;
        const {type,size} = request;
        const formats = ['image/jpg', 'image/jpeg', 'image/png', 'image/svg', 'image/bmp', 'image/gif', 'image/svg+xml', 'video/mp4']
        if(type==='video/mp4' && size > 15) {
          return {
            ...state,
            uploadError:true,
            errorType: 'The video size should be less than 15mb.',
          };
        }
        if(!formats.includes(type)) {
          return {
            ...state,
            uploadError:true,
            errorType: 'Unsupported file format.',
          };
        }
        var uploads = [...state.uploads, request];
        uploads = _.uniqBy(uploads, 'id');
  
        return {
          ...state,
          uploads: uploads,
        }
      }
  
      case BRANDKIT_INVALIDATE_MEDIA_UPLOAD_ERROR: {
        return {
          ...state,
          uploadError: false,
        }
      }
  
      case BRANDKIT_UPDATE_MEDIA_UPLOAD_PROGRESS: {
        const { id, progress } = action.payload;
  
        var uploads = state.uploads.map(media => {
          if (media.id === id) {
            return {
              ...media,
              progress: progress,
            }
          }
  
          return media;
        })
  
        return {
          ...state,
          uploads: uploads
        }
      }
  
      case BRANDKIT_UPLOAD_MEDIA_REQUEST: {
        const { id } = action.payload;
  
        var uploads = state.uploads.map(media => {
          if (media.id === id) {
            return {
              ...media,
              processing: true
            }
          }
          return media;
        })
  
        return {
          ...state,
          uploads: uploads,
        }
      }
  
      case BRANDKIT_UPLOADING_MEDIA_SUCCEEDED: {
        const { id, response } = action.payload;
  
        var uploads = state.uploads.filter(media => {
          return media.id != id;
        });
  
        var items = [response, ...state.items];
        items = _.uniqBy(items, 'id');
        items = _.orderBy(items, 'createdDate', 'desc');
  
        return {
          ...state,
          uploads: uploads,
          items,
        }
      }
  
      case BRANDKIT_UPLOADING_MEDIA_FAILED: {
        const { id, error } = action.payload;
  
        var uploads = state.uploads.map(media => {
          if (media.id === id) {
            return {
              ...media,
              processing: false,
              error: error
            }
          }
  
          return media;
        })
  
        return {
          ...state,
          uploads: uploads
        }
      } 
  
      case BRANDKIT_SEARCH_MEDIA_REQUEST: {
        return {
          ...state,
            loading: true
          }
        }
  
      case BRANDKIT_SEARCHING_MEDIA_SUCCEEDED: {
        const { records, ...pagination } = action.payload.response;
    
        if (pagination.currentPage !== 0) {
          items = [...state.items, ...records];
        } else {
          items = records;
        }
        
        items = _.uniqBy(items, 'id');
        
        return {
          ...state,
          loading: false,
          fetched: true,
          items: items,
          pagination: pagination
        }
      }
  
      case BRANDKIT_SEARCHING_MEDIA_FAILED: {
        return {
          ...state,
          loading: false,
          error: action.payload
        }
      }
  
      case BRANDKIT_DELETE_MEDIA_REQUEST: {
        return {
          ...state,
          deleting: true,
        }
      }
  
      case BRANDKIT_DELETING_MEDIA_SUCCEEDED: {
        const { ids, response } = action.payload;
        
        const items = state.items.filter(item => (!(ids).includes(item.id)));
  
        return {
          ...state,
          loading: false,
          deleting: false,
          items: items,
        }
      }
  
      case BRANDKIT_DELETING_MEDIA_FAILED: {
        return {
          ...state,
          deleting: false,
          loading: false,
          error: action.payload.error[0]
        }
      }
  
      case BRANDKIT_INVALIDATE_MEDIA_LIBRARY: {
        return initialState;
      }
  
      case BRANDKIT_INVALIDATE_MEDIA_DELETE_ERROR:{
        return{
          ...state,
          error:false
        }
      }

      case RELOAD_EDITOR_BRAND_COMPONENT_SUCCEEDED: {
        const { response, type } = action.payload;

        if(type !== 'MEDIA') {
          return state;
        }

        let items = [response, ...(state.items || [])];
        items = _.uniqBy(items, 'id');

        return {
          ...state,
          items,
        }
      }
  
      default:
        return state;
    }
  }